import api from './api';

export function getRangoHorarios(token) {
  const tLinea = `linea=501`;

  return api.get(`v1/rangos?${tLinea}`, {
    headers: {
      Authorization: token,
    },
  });
}
